import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import ThreatList from "@/pages/ThreatList";
export const Route = createFileRoute("/threats")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><ThreatList /></ProtectedRoute>) });
